import React from "react";
import Newslettersub from "./components/newslettersub";
import NavSection from "./components/navSection";

const Footer = () => {
  return (
    <footer 
      className="px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 pt-10 pb-4 flex flex-col bg-white font-['Poppins']"
      style={{
        borderTop: '1px solid',
        borderImageSource: 'linear-gradient(90deg, rgba(63, 177, 133, 0) 0%, rgba(49, 50, 50, 0.4) 52.12%, rgba(63, 177, 133, 0) 100%)',
        borderImageSlice: 1
      }}
    >
      {/* Main Footer Content */}
      <div className="flex flex-col lg:flex-row lg:justify-between gap-8 lg:gap-4">
        {/* Left Section - Logo, Tagline, Newsletter, Social */}
        <div className="flex flex-col gap-6 lg:max-w-[300px]">
          {/* Logo and Tagline */}
          <div className="flex items-start gap-3">
            <img
              src="logo.svg"
              alt="Hailing Trades"
              className="w-12 h-12 object-contain"
            />
            <p className="text-gray-600 text-sm leading-relaxed">
              Find the Right Professional for your Job. Trusted Experts Near You
            </p>
          </div>

          {/* Newsletter */}
          <Newslettersub />

          {/* Social Media */}
          <div className="flex items-center gap-2">
            <a
              href="https://www.facebook.com/profile.php?id=61575836705459"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-200 hover:border-primary transition-colors rounded-full"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14 0H4C2.0195 0 0 2.06406 0 4V14C0 16.0193 2.03189 18 4 18H9.621V11.039H7.278V8.52075H9.621V6.309C9.621 3.985 11.042 2.718 13.116 2.718C13.815 2.716 14.51 2.718 15.208 2.718V5.253H13.78C12.65 5.253 12.43 5.787 12.43 6.575V8.51675H14.9604L14.3791 11.035H12.414V18H14C16.0361 18 18 15.9905 18 14V4C18 2.02499 16.0208 0 14 0Z"
                  fill="#1C1C1C"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/hailing_trades?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-gray-200 hover:border-primary transition-colors rounded-full"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14 0C16.2091 0 18 1.79086 18 4V14C18 16.2091 16.2091 18 14 18H4C1.79086 18 0 16.2091 0 14V4C0 1.79086 1.79086 0 4 0H14ZM9 4C6.23858 4 4 6.23858 4 9C4 11.7614 6.23858 14 9 14C11.7614 14 14 11.7614 14 9C14 6.23858 11.7614 4 9 4ZM9 6C10.6569 6 12 7.34315 12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9C6 7.34315 7.34315 6 9 6ZM15 2C14.4477 2 14 2.44772 14 3C14 3.55228 14.4477 4 15 4C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2Z"
                  fill="#1C1C1C"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Navigation Sections */}
        <NavSection />
      </div>

      {/* Bottom Copyright */}
      <div className="text-center text-gray-500 text-sm mt-10 pt-6 border-t border-gray-200">
        2025 All Rights Reserved . By{" "}
        <a
          href="https://feur.com.au/"
          target="_blank"
          rel="noreferrer"
          className="text-primary hover:underline transition-colors"
        >
          Feur Media House
        </a>
      </div>
    </footer>
  );
};

export default Footer;
